<template>
  <label class="switch-toggle flex cursor-pointer items-center">
    <div class="relative">
      <input v-model="bool" type="checkbox" class="sr-only" :disabled="props.disabled" />
      <div
        class="block h-5 w-8 rounded-full duration-500"
        :class="{
          'bg-cdp-black-300': !bool,
          'bg-cdp-main-primary': bool,
          'bg-cdp-grey-400': props.disabled
        }"
      />
      <div
        class="dot absolute top-1 h-3 w-3 rounded-full bg-cdp-white shadow-md"
        :class="{
          '-left-1': bool,
          'left-1': !bool
        }"
      />
    </div>
  </label>
</template>

<script>
import { computed, defineComponent } from 'vue';
export default defineComponent({
  /**
   * 最初註冊名稱與檔案名稱開頭大小寫不一致，故針對此命名（Histoire 讀檔用）
   */
  name: 'SwitchToggle',
  props: {
    modelValue: {
      type: Boolean,
      require: true,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const bool = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit('update:modelValue', val);
        emit('change');
      }
    });
    return {
      props,
      bool
    };
  }
});
</script>